export enum AuditLogLevel {
    ALL = 'ALL',
    DEBUG = 1,
    INFO = 2,
    ERROR = 3,
}